/* eslint-disable react/no-danger */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { CMP_VENDOR, consentGatedScriptProps } from '@/constants/consentManager';

interface GoogleAnalyticsProps {
  gaIds: string[];
  clientId?: string;
}

export function GoogleAnalytics(props: GoogleAnalyticsProps) {
  const { gaIds, clientId } = props;
  let injectGAString = `
  window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date());
  `;
  gaIds.forEach((gaId) => {
    injectGAString += `gtag('config', '${gaId}');`;
  });
  if (clientId) {
    injectGAString += `gtag('set', 'user_properties', {'ClientId':'${clientId}'});`;
  }
  // Held back by the CMP until the visitor consents to Google Analytics.
  return (
    <>
      {gaIds.map((gaId) => (
        <script
          key={gaId}
          {...consentGatedScriptProps(CMP_VENDOR.googleAnalytics)}
          data-cmp-src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        />
      ))}
      <script
        {...consentGatedScriptProps(CMP_VENDOR.googleAnalytics)}
        dangerouslySetInnerHTML={{ __html: injectGAString }}
      />
    </>
  );
}
